const joinLinks = (list) => list.map(o => o.link).join()

export const compareTwoLinkArrays = (existingList = [], newList = []) => {
  const existing = joinLinks(existingList);
  const newListIdentifier = joinLinks(newList);
  return existing !== newListIdentifier;
};
